/*
 * actions - 封装系统里各种数据请求接口。
 */
import Vue from 'vue'
import qs from 'qs'
import _ from '../typeof'

/**
 * 根据传入的url、method以及data数据发起请求，并返回一个promise对象。
 * @param {请求地址} url
 * @param {请求方法，'GET'或者'POST'或者'PUT'} method
 * @param {请求数据，应该为json对象} data
 */
export default function request (
  url,
  method = 'GET',
  data,
  option = { headers: { 'content-type': 'application/json;charset=UTF-8' }, responseType: '' },
  extra = { options: { url: '', method: '' } } // 这个字段用于方便plugins中拓展一些功能
) {
  if (!_.isObject(extra)) {
    return console.error('参数extra必须为对象 at src/request/index.js')
  }
  let payload = extra.options || {}
  payload.url = url
  payload.method = method
  payload.headers = payload.headers || option.headers || {}
  payload.responseType = payload.responseType || option.responseType || ''
  let headers = payload.headers
  if (!payload.params && !payload.data) {
    // 如果extra.options中没有指定参数放置位置，使用默认策略
    if (method.toLocaleLowerCase() === 'get') {
      // get方法默认将参数放到params（即用？的形式跟参数）
      payload.params = data
    } else if (method === 'multipleFILE') { // 多文件上传，已经是form-data
      return Vue.prototype.$http.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
    } else {
      if (option.headers['content-type'] !== 'application/json;charset=UTF-8') {
        payload.data = qs.stringify(data)
      } else {
        payload.data = data
      }
      // 下载文件时，特殊处理数据
      let responseType = option.responseType
      if (responseType === 'arraybuffer' || responseType === 'blob') {
        headers['Content-Type'] = option.headers['content-type']
        if (option.headers.filename) {
          headers['filename'] = option.headers.filename
        }
        headers['responseType'] = responseType
        return Vue.prototype.$http.post(url, data, headers).catch(err => {
          return handleError(err)
        })
      }
    }
  }
  return Vue.prototype.$http(payload).catch(err => {
    return handleError(err)
  })
}

export function handleError (err) {
  let message = ''
  // console.error('err---',err)
  // 处理请求类型为blob时
  if (err.response.request.responseType === 'blob') {
    return new Promise((resolve, reject) => {
      let data = err.response.data
      var reader = new FileReader()
      reader.readAsText(data, 'utf-8')
      reader.onload = function () {
        data = JSON.parse(reader.result)
        reject(parseError(data))
      }
    })
  } else {
    let data = err.response
    message = parseError(data)
    return Promise.reject(message)
  }
}
export function parseError (data) {
  let { status } = data
  let { detail } = data.data || data
  detail = detail || '请求错误'
  if (status >= 500) {
    return '好像出了点意外，请稍后重试'
  } else if (status === 400) {
    return detail
  } else if (status === 401) {
    return '您未登录或登录已过期，请重新登录'
  } else if (status === 403) {
    return '您没有访问该信息的权限，请切换账号或联系系统管理员'
  } else if (status === 404) {
    return '未找到相关资源'
  } else if (status === 405) {
    return '该接口不支持指定的方法'
  }
  return '未知错误'
}
